export const externalLinks = {
  privacyAgreement:
    'https://www.tannlegeforeningen.no/download/18.2303676d18f9eb9e95aa7cfc/1717402551869/PERSONVERNERKL%C3%86RING%20FOR%20BRUKERE%20AV%20SYKEHJELPSORDNINGEN.pdf',
  sykehjelpsordningen:
    'https://www.tannlegeforeningen.no/jus-og-arbeidsliv/ved-sykdom-og-svangerskap-/sykehjelpsordningen.html',
  tannlegeforeningen: 'https://www.tannlegeforeningen.no',
}
